import activePortCall from './activePortCall'
import activePortCallsFilterBy from './activePortCallsFilterBy'
import baplieInfoStatus from './baplieInfoStatus'
import browserNotificationPermissionStatus from './browserNotificationPermissionStatus'
import cargoOperationsTrend from './cargoOperationsTrend'
import chartLegend from './chartLegend'
import chartXAxisTicks from './chartXAxisTicks'
import containerMovesProgress from './containerMovesProgress'
import containerNotes from './containerNotes'
import departureAndCompletionTime from './departureAndCompletionTime'
import drafts from './drafts'
import draftSurvey from './draftSurvey'
import fleet from './fleet'
import gantryMovesSummary from './gantryMovesSummary'
import gantryProductivityChartData from './gantryProductivityChartData'
import gantryProductivitySummary from './gantryProductivitySummary'
import gantryTimeline from './gantryTimeline'
import logbookRemarks from './logbookRemarks'
import milestones from './milestones'
import navigation from './navigation'
import notificationsFilter from './notificationsFilter'
import pinnedPort from './pinnedPort'
import pinnedShip from './pinnedShip'
import port from './port'
import portCall from './portCall'
import portCallCargoOps from './portCallCargoOps'
import portCallComment from './portCallComment'
import portCallGeneral from './portCallGeneral'
import portCallMoves from './portCallMoves'
import portCallNotification from './portCallNotification'
import portCallNotifications from './portCallNotifications'
import portCallProductivity from './portCallProductivity'
import portCallReport from './portCallReport'
import portCallsPagination from './portCallsPagination'
import portPagination from './portPagination'
import recentlyCompleted from './recentlyCompleted'
import recentlyCompletedPortCalls from './recentlyCompletedPortCalls'
import reports from './reports'
import scheduleStatus from './scheduleStatus'
import ship from './ship'
import shipOverview from './shipOverview'
import shipOverviewBay from './shipOverviewBay'
import shipOverviewDevice from './shipOverviewDevice'
import shipOverviewMilestones from './shipOverviewMilestones'
import terminalPerformanceReport from './terminalPerformanceReport'
import userRole from './userRole'
import vesselInfo from './vesselInfo'
import workingAndIdleTime from './workingAndIdleTime'

export default {
  activePortCall,
  activePortCallsFilterBy,
  baplieInfoStatus,
  browserNotificationPermissionStatus,
  cargoOperationsTrend,
  chartLegend,
  chartXAxisTicks,
  containerMovesProgress,
  containerNotes,
  departureAndCompletionTime,
  draftSurvey,
  drafts,
  fleet,
  gantryMovesSummary,
  gantryProductivityChartData,
  gantryProductivitySummary,
  gantryTimeline,
  logbookRemarks,
  milestones,
  navigation,
  notificationsFilter,
  pinnedPort,
  pinnedShip,
  port,
  portCall,
  portCallCargoOps,
  portCallComment,
  portCallGeneral,
  portCallMoves,
  portCallNotification,
  portCallNotifications,
  portCallProductivity,
  portCallReport,
  portCallsPagination,
  portPagination,
  recentlyCompleted,
  recentlyCompletedPortCalls,
  reports,
  scheduleStatus,
  ship,
  shipOverview,
  shipOverviewBay,
  shipOverviewDevice,
  shipOverviewMilestones,
  terminalPerformanceReport,
  userRole,
  vesselInfo,
  workingAndIdleTime,
}
